import React from 'react';
import clsx from 'clsx';
import styles from './StatusLabel.module.scss';

type LabelVariant = 'info' | 'success' | 'error';

interface Props {
  variant?: LabelVariant;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export function StatusLabel({
  variant = 'info',
  children,
  onClick,
  className
}: Props) {
  return (
    <div
      className={clsx(styles.label, styles[variant], className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
